/**
 * FDV — urgencia REAL en la línea del regalo del carrito (9-oct-2026).
 *
 * <fdv-gift-urgency data-ends-at="<epoch s>" data-stock="<n>"> lo pinta cart-products.liquid
 * solo en la línea de un regalo con oferta de cierre. Dos datos, los dos reales:
 *   - el reloj corre hasta `end_at` de la oferta (metaobjeto `fdv_gift_offer`);
 *   - las piezas salen del inventario de la variante regalo (Liquid, al renderizar el carrito).
 * Un solo intervalo global actualiza todos los elementos de la página: sobrevive al
 * `morphSection` de Horizon (que reemplaza el DOM del carrito) sin depender de connectedCallback.
 */
function fmt(ms) {
  const t = Math.max(0, Math.floor(ms / 1000));
  const h = Math.floor(t / 3600);
  const m = Math.floor((t % 3600) / 60);
  const s = t % 60;
  const p = (n) => String(n).padStart(2, '0');
  return `${p(h)}:${p(m)}:${p(s)}`;
}

function tick() {
  document.querySelectorAll('fdv-gift-urgency').forEach((el) => {
    const ends = Number(el.dataset.endsAt) * 1000;
    const stock = Number(el.dataset.stock);
    const timer = el.querySelector('[data-fdv-urgency-timer]');
    const left = ends - Date.now();
    if (!ends || left <= 0 || (Number.isFinite(stock) && stock <= 0)) {
      el.hidden = true;
      return;
    }
    el.hidden = false;
    if (timer) timer.textContent = fmt(left);
  });
}

if (!window.__fdvGiftUrgency) {
  window.__fdvGiftUrgency = setInterval(tick, 1000);
  tick();
}
